import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M285 280h-36.8C248.2 145.9 139.1 36.8 5 36.8V0c154.4 0 280 125.6 280 280zm-88.4 0h-36.8c0-85.5-69.3-154.7-154.7-154.7V88.4c105.6 0 191.5 85.9 191.5 191.6zM47.4 195.3c23.4 0 42.4 19 42.4 42.4S70.8 280 47.4 280 5 261 5 237.6s19-42.3 42.4-42.3z"
})), 'RssIcon');